export const FETCH_ROLES = 'FETCH_ROLES';
export const POST_ROLE = 'POST_ROLE';
